module.exports = __webpack_public_path__ + "static/media/startup-adv-icon.06252c96.png";